import { language as lan_standardOrderContent } from "./standard-order-detail-content";
import { language as lan_standardOrderTip } from "./standard-order-detail-tip";

let language = {
    ...lan_standardOrderContent,
    ...lan_standardOrderTip,
};

export { language }